/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "controllers"
import * as Turbo from "@hotwired/turbo"
import debounced from 'debounced'
import BSN from 'bootstrap.native/dist/bootstrap-native-v4-esm.min.js'
import Rails from '@rails/ujs';
import setupCSRFToken from '../src/csrf-token'

import { polyfillRequestSubmit } from "../src/polyfills"
polyfillRequestSubmit()

Rails.start();

// TODO: Check if we can remove BSN entirely and just use Stimulus.
document.addEventListener("turbo:load", () => BSN.initCallback(document.body))

// Provides debounced event handlers/triggers, defaults to 200ms.
debounced.initialize({ ...debounced.events, input: { wait: 350 } })

// CSRF setup for axios
setupCSRFToken()
